import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import usePageTracking from "../../../hooks/usePageTracking";
import { activityStart, activityEnd } from "../../../redux/slices/trackActivitySlice";
import "./orders.scss";
import { fetchOrders } from "../../../redux/slices/shopSlice";
import { useNavigate } from "react-router-dom";
import { FiArrowLeft } from "react-icons/fi";
import { Card } from "react-bootstrap";

const Orders = () => {
  const dispatch = useDispatch();

  // Track Activity
  usePageTracking("MY_ORDERS");
  useEffect(() => {
    dispatch(activityStart({ page_name: "MY_ORDERS", platform: "web" }));
    return () => dispatch(activityEnd({ page_name: "MY_ORDERS" }));
  }, [dispatch]);
  const { orders, loading } = useSelector((state) => state.shop);
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(fetchOrders());
  }, [dispatch]);

  const filteredOrders = orders.filter((order) => order.status !== "pending");

  return (
    <div className="orders-wrapper">
      <div className="orders-container">
        {/* <div className="orders-header">
            <h6>Order History</h6>
            <p>
              {filteredOrders.length} Order
              {filteredOrders.length !== 1 && "s"} Found
            </p>
        </div> */}
        <div className="app-page-title">
          <div className="page-title-heading d-flex">
            {/* <FiArrowLeft
              size={40}
              className="icon cursor-pointer"
              onClick={() => navigate("/shop/products")}
            /> */}
            <h3 className="page-title"><span>Order History</span>

          <p>
            {filteredOrders.length} Order
            {filteredOrders.length !== 1 && "s"} Found
          </p>
            </h3>
          </div>
        </div>

        {loading && orders.length === 0 && (
          <div className="loader-wrapper">
            <div className="spinner"></div>
            <p className="loader-text">Loading your orders...</p>
          </div>
        )}
        {!loading && filteredOrders.length === 0 && (
          <div className="empty-state text-center">
            <h6>No Orders Yet</h6>
            <p className="mb-0 pb-0">Your completed or processing orders will appear here.</p>
          </div>
        )}

        <div className="orders-grid">
          {filteredOrders.map((order) => {
            const totalItems = order.line_items.reduce(
              (acc, item) => acc + item.quantity,
              0,
            );

            return (
              <Card key={order.id} className="order-card">
                <Card.Body>
                  {/* Column 1 */}
                  <div className="order-info">
                    <h3>Order #{order.number}</h3>
                    <span className="date">
                      {new Date(order.date_created).toLocaleDateString([], {
                        year: "numeric",
                        month: "short",
                        day: "numeric",
                      })}
                    </span>

                    <span
                      className={`status-badge ${order.status.toLowerCase()}`}
                    >
                      {order.status}
                    </span>
                  </div>

                  {/* Column 2 */}
                  <div className="product-list">
                    {order.line_items.map((item) => (
                      <div key={item.id} className="product-item">
                        <span className="qty">{item.quantity}x</span>
                        {item.name}
                      </div>
                    ))}
                  </div>

                  {/* Column 3 */}
                  <div className="total-section">
                    <span className="label">Total</span>
                    <span className="price">
                      {order.currency_symbol}
                      {order.total}
                    </span>
                    <span className="items-pill">
                      {totalItems} item{totalItems !== 1 && "s"}
                    </span>
                  </div>

                  {/* Column 4 */}
                  <div className="buttons">
                    <button
                      className="btn btn-primary"
                      onClick={() => navigate(`/shop/order-detail/${order.id}`)}
                    >
                      View Details
                    </button>
                  </div>
                </Card.Body>
              </Card>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Orders;
